<template>
    <div style="margin: 0 auto 20px auto;" :style="$vuetify.breakpoint.mobile ? 'width: 100%; padding: 0 30px;' : 'width: 1024px;'">
        <v-row>
            <v-col class="py-1 px-0" v-for="data in datas" :key="data.id" :cols="(!(data.type_ui) && data.show && ! ['current_type', 'contact_access', 'button', 'profile', 'status'].includes(data.id)) ? 6 : 12" >
                <div style="display: flex;" v-if="!(data.type_ui) && data.show && ! ['current_type', 'contact_access', 'button', 'profile', 'status'].includes(data.id)">
                    <span style="min-width: 170px;">{{ data.name }}</span>
                    <span >: {{ data.value }}</span>
                </div>

                <fieldset v-if="data.type_ui && data.type_ui === 'card'" style="padding: 0 10px; border-radius: 5px; border-width: 0; border: 2px solid #e4e4e4;">
                    <legend style="padding: 0 6px">{{ data.name }}</legend>
                        <v-row>
                            <v-col class="py-1 px-0" v-for="card in data.value" :key="card.id" cols="6">
                                <div style="display: flex;">
                                    <span style="min-width: 170px;">{{ card.name }}</span>
                                    <span >: {{ card.value }}</span>
                                </div>
                            </v-col>
                        </v-row>
                </fieldset>
            </v-col>
        </v-row>
    </div>
</template>

<script>

    import OptionDataMixin from "../../../../mixins/optionDataMixin";
    import MainMixin from "../../../../mixins/mainMixin";
    import ValidatorMixin from "../../../../mixins/validatorMixin";

    export default {
        name: "membershipPersonalInformation",
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        data() {
            return {};
        },
        computed: {
            datas(){
                return this.$store.state.membership.tab_items
            }
        },  
        methods: {},
        watch: {}
    };
</script>
